import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const OkInformationOnline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        total
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postokonline, loading } = useFormsStore()

    // const canvasRef = useRef(null)
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')






    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            filingStatus: values?.Filing_status,
            allowanceForYourself: values?.allowanceforyourself ? Number(values?.allowanceforyourself) : null,
            allowanceForYourSpouse: values?.allowanceforspouse ?? null,
            allowanceForDependents: values?.allowancefordependents ? Number(values?.allowancefordependents) : 0,
            totalNumberOfAllowances: total,
            additionalWithholdingPerPayPeriod: values?.additionalwitholdingperpayperiod ? Number(values?.additionalwitholdingperpayperiod) : null,
            exemptStatus: values?.exemptstatus ? values?.exemptstatus?.toUpperCase() : null,
            oklahomaTaxExemptStatus: values?.oklahoma_tax_exempt_status ? values?.oklahoma_tax_exempt_status?.toUpperCase() : null,
            isMilitaryIncomeExempt: values?.is_military_income_exempt ? values?.is_military_income_exempt?.toUpperCase() : null,
            additionalAllowances: values?.additionalallowances ? Number(values?.additionalallowances) : null,
            sign: signatureDataURL
        }
        const response = await postokonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'OK Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('OkInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default OkInformationOnline
